export default __webpack_public_path__ + "static/spet3-86b6a7db010f29d550d287243b976eb9.jpg";